import React, { useContext, useEffect, useRef, useState } from 'react';
import client from '../../apollo-client';
import Included from '../../components/TourPage/Included';
import { PaxContext } from '../../utils/context/checkoutContext';
import AddReviewModal from '../../components/TourPage/ProductReviews/AddReviewModal';
import CountMessage from '../../components/TourPage/CountMessage';
import { FETCH_RECENT_BOOKINGS } from '../../api/fetch_recent_bookings';
const Link = dynamic(() => import('next/link'));
import Head from 'next/head';
import { useRouter } from 'next/router';
import Image from 'next/image';
import {
  FETCH_REVIEW_AGGREGATE_TOURS,
  FETCH_REVIEW_COUNTS_BY_RATING,
  CHECK_EXISTING_REVIEW_BY_BOOKING_ID
} from '../../api/reviews';
import { view_item } from '../../utils/googleTransaction';
const RelatedTours = dynamic(
  () => import('../../components/TourPage/RelatedTours')
);
const Newsletter = dynamic(() => import('../../layouts/Newsletter/Newsletter'));
import { GetServerSideProps } from 'next';
import ShareButton from '../../shared-components/AttractionCard/ShareButton';
import Footer from '../../layouts/Footer/footer';
import { WhatYouWillSeeSection } from '../../components/TourPage/WhatYouWillSeeSection';
import { NeedToKnow } from '../../components/TourPage/NeedToKnow';
import { BOOKING_DATA } from '../../api/fetch_user_details';
const ReviewsSection = dynamic(
  () => import('../../components/TourPage/ProductReviews/ProductReviews')
);
import { Review } from '../[slug]/[slug2]';
import axios from 'axios';
import { BestReview, Product } from '../../types/pages/tour';
import dynamic from 'next/dynamic';
import { replaceTripshepherdWithSeeSight } from '../../utils/trip-sheppered-text';
import scrollToElement from '../../utils/scrollIntoView';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { Rating } from 'react-simple-star-rating';
const PhotosHeader = dynamic(
  () => import('../../components/TourPage/PhotosHeader')
);
import KeyDetails from '../../components/TourPage/KeyDetails';
import getTimeAgo from '../../utils/getDateTime';
import DetailedReviewModal from '../../shared-components/testimonials/detailedReviewModal';
import InclusionExclusionGrid from '../../components/TourPage/InclusionExclusionGrid';
import TourDetailedInfo from '../../components/TourPage/TourDetailedInfo';
import HtmlInfoSection from '../../components/TourPage/HtmlInfoSection';
const TourRouteMap = dynamic(
  () => import('../../components/TourPage/TourRouteMap'),
  { ssr: false }
);
import 'swiper/css';
import 'swiper/css/navigation';
import { useMediaQuery } from '../../hooks/mediaQuery';
import { FETCH_STRAPI_PRODUCT_ID } from '../../api/keywordLandingPage';
import { FETCH_REVIEWS } from '../../api/reviews';
import ProductReviewCard from '../../components/TourPage/ProductReviews/ProductReviewCard';

interface TourPageProps {
  product: Product;
  initialReviews: Review[];
  modifiedBestReview: BestReview;
  modifiedSecondMostPositiveReview: Review;
  modifiedPositiveReview: Review;
  totalCount: number;
  count: number;
  toursStrapiId: number;
}

interface BookingData {
  boatnew_booking: Array<{
    tour_date: string;
    product: {
      id: string;
      strapi: {
        id: string;
      };
      cities_products: Array<{
        city: {
          name: string;
          id: string;
          strapi_city: {
            id: string;
          };
        };
      }>;
    };
    customer: {
      contact_name: string;
      email: string;
    };
  }>;
}
const TourPage = ({
  product,
  initialReviews,
  totalCount,
  count,
  toursStrapiId
}: TourPageProps) => {
  const router = useRouter();
  //@ts-ignore
  const { updateTour, currency, updateCurrency } = useContext(PaxContext);

  // State to store the selected price based on the current currency
  const [selectedPrice, setSelectedPrice] = useState<
    Price | null | undefined
  >();
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewFormData, setReviewFormData] = useState({
    name: '',
    email: '',
    rating: 0,
    reviewTitle: '',
    reviewText: '',
    tourDate: '',
    productId: '',
    cityId: '',
    bookingId: ''
  });

  const [bookingId, setBookingId] = useState('');

  const [isValidBooking, setIsValidBooking] = useState(false);

  const [bookingCheckComplete, setBookingCheckComplete] = useState(false);

  const [bookingErrorMessage, setBookingErrorMessage] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedReviewData, setSelectedReviewData] = useState<Review | null>(
    null
  );
  const Mobile = useMediaQuery(767);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailModalData, setDetailModalData] = useState<any>(null);

  const [ratingCounts, setRatingCounts] = useState<{ [key: number]: number }>(
    {}
  );

  // Mobile gallery state
  const [showMobileGallery, setShowMobileGallery] = useState(false);
  const [bookingIdFromStorage, setBookingIdFromStorage] = useState<
    string | null
  >(null);

  useEffect(() => {
    const storedBookingId = localStorage.getItem('bookingId');
    if (storedBookingId) {
      setBookingIdFromStorage(storedBookingId);
    } else {
      setBookingIdFromStorage(null);
    }

    // Listen for storage changes (e.g., when localStorage is cleared from another tab)
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'bookingId') {
        if (e.newValue) {
          setBookingIdFromStorage(e.newValue);
        } else {
          setBookingIdFromStorage(null);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);
  const [showCountMessage, setShowCountMessage] = useState(true);
  const [recentBookingsCount, setRecentBookingsCount] = useState(0);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  useEffect(() => {
    const { id } = router.query;
    const bookingIdToUse =
      bookingIdFromStorage || (id && typeof id === 'string' ? id : null);
    if (bookingIdToUse) {
      setBookingId(bookingIdToUse);
      checkBookingValidity(bookingIdToUse);
    } else {
      setBookingCheckComplete(true);
    }
  }, [router.query, bookingIdFromStorage]);

  const checkBookingValidity = async (bookingId: string) => {
    try {
      const existingReviewResponse = await client.query({
        query: CHECK_EXISTING_REVIEW_BY_BOOKING_ID,
        variables: { bookingId },
        fetchPolicy: 'no-cache'
      });

      const existingReviews = existingReviewResponse.data?.strapi_reviews || [];

      if (existingReviews.length > 0) {
        setIsValidBooking(false);
        setBookingCheckComplete(true);
        return;
      }
      const response = await client.query({
        query: BOOKING_DATA,
        variables: { bookingId }
      });

      const bookingData: BookingData = response.data;

      if (bookingData.boatnew_booking.length === 0) {
        setIsValidBooking(false);
        setBookingErrorMessage(`Booking ID ${bookingId} does not exist.`);
      } else {
        const booking = bookingData.boatnew_booking[0];

        if (booking.product.id === product.id) {
          setIsValidBooking(true);
          setReviewFormData({
            name: booking.customer.contact_name || '',
            email: booking.customer.email || '',
            rating: 0,
            reviewTitle: '',
            reviewText: '',
            tourDate: booking.tour_date || '',
            productId: product.id,
            cityId:
              booking.product.cities_products[0]?.city.strapi_city.id || '',
            bookingId: bookingId
          });
          setShowReviewModal(true);
          setTimeout(() => {
            const reviewsSection = document.getElementById('important-info');
            if (reviewsSection) {
              reviewsSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }, 100);
        } else {
          setIsValidBooking(false);
          if (showReviewModal) {
            setBookingErrorMessage(
              `Booking ID ${bookingId} is not valid for this product.`
            );
          }
        }
      }
    } catch (error) {
      console.error('Error checking booking validity:', error);
      setIsValidBooking(false);
      setBookingErrorMessage('An error occurred while checking the booking.');
    } finally {
      setBookingCheckComplete(true);
    }
  };
  // Function to check for existing booking review when user clicks Add Review button
  const checkExistingBookingReview = async () => {
    if (!bookingId) return false;

    try {
      const existingReviewResponse = await client.query({
        query: CHECK_EXISTING_REVIEW_BY_BOOKING_ID,
        variables: { bookingId },
        fetchPolicy: 'no-cache'
      });
      const existingReviews = existingReviewResponse.data?.strapi_reviews || [];
      return existingReviews.length > 0;
    } catch (error) {
      console.error('Error checking existing booking review:', error);
      return false;
    }
  };

  useEffect(() => {
    if (bookingErrorMessage) {
      toast.error(bookingErrorMessage);
      // Scroll to reviews section so user can see existing reviews
      setTimeout(() => {
        const reviewsSection = document.getElementById('reviews-section');
        if (reviewsSection) {
          reviewsSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 1000);
    }
  }, [bookingErrorMessage]);
  useEffect(() => {
    updateCurrency(currency);

    const price = Array.isArray(product?.productPrices)
      ? product.productPrices.find(price => price.currency === currency)
      : null;
    setSelectedPrice(price);
  }, [currency, product?.productPrices]);

  const descriptionRef = useRef<HTMLDivElement | null>(null);
  const footerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (router.asPath.includes('#reviews')) {
      const cleanPath = router.asPath.split('#')[0];
      router.replace(cleanPath, undefined, { shallow: true });
      window.scrollTo(0, 0);
    }
  }, [router]);

  useEffect(() => {
    view_item({
      item_id: product?.id,
      item_name: product?.name,
      item_price: JSON.stringify(selectedPrice?.prices.adult),
      currency_code: currency
    });
  }, []);
  const scrollToSection = (elementId: string, offset: number = 0) => {
    const element = document.getElementById(elementId);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset + offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  //@ts-ignore
  const reviewsAggregate = product?.pageContent?.reviews_aggregate;
  const reviewCount: number = reviewsAggregate?.aggregate?.count || 0;
  const [averageRating, setAverageRating] = useState(0);

  const totalRating: number = reviewsAggregate?.aggregate?.sum?.rating || 0;

  const [bestReview, setBestReview] = useState<BestReview>();
  const [secondMostPositiveReview, setSecondMostPositiveReview] =
    useState<Review>();
  const [positiveReview, setPositiveReview] = useState<Review>();

  const [reviews, setReviews] = useState<Review[]>(initialReviews);
  const [selectedRating, setSelectedRating] = useState<string>('');
  const [currentPage, setCurrentPage] = useState(1);
  const [reviewsCount, setReviewsCount] = useState(count);
  const [totalReviewsCount, setTotalReviewsCount] = useState(totalCount);
  const [loader, setLoader] = React.useState(false);
  const [showPax, setShowPax] = useState<boolean>(false);
  const [isPaxVisible, setIsPaxVisible] = useState<boolean>(false);
  const paxRef = useRef<HTMLDivElement>(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const itemsPerPage = router.asPath.includes('/tours/') ? 6 : 5;
  const fetchReviewAggregate = async () => {
    try {
      if (!toursStrapiId) return;

      // Build where clause for review aggregate
      const aggregateWhereClause: any = {
        product: { _eq: toursStrapiId },
        rating: { _gte: 4 }
      };

      const response = await client.query({
        query: FETCH_REVIEWS,
        variables: {
          where: aggregateWhereClause
        },
        fetchPolicy: 'no-cache'
      });
      const reviews = response.data?.strapi_reviews || [];
      const newCount = reviews.length;
      const totalRating = reviews.reduce(
        (sum: number, review: any) => sum + (review.rating || 0),
        0
      );
      const newRating =
        newCount > 0 ? parseFloat((totalRating / newCount).toFixed(1)) : 0;
      setTotalReviewsCount(newCount);
      setAverageRating(newRating);
    } catch (error) {
      console.error('Failed to fetch review aggregate:', error);
    }
  };
  const whereClause: any = {
    product: { _eq: toursStrapiId },
    rating: { _gte: 4 }
  };

  const fetchBestReviews = async () => {
    try {
      // Build where clause for best reviews
      const bestReviewsWhereClause: any = {
        ...whereClause,
        rating: { _gte: 4 }
      };

      const responseBest = await client.query({
        query: FETCH_REVIEWS,
        variables: {
          limit: 2,
          order_by: [{ created_at: 'desc' }],
          where: bestReviewsWhereClause
        },
        fetchPolicy: 'no-cache'
      });
      if (responseBest?.data?.strapi_reviews) {
        const reviews = responseBest?.data?.strapi_reviews;

        const processedReviews = reviews?.map((review: any) => ({
          ...review,
          name: review?.traveller,
          created_at: review?.created_at
        }));

        setBestReview({
          ...processedReviews[0],
          name: processedReviews[0]?.traveller
        });

        setPositiveReview(
          processedReviews[0]
            ? {
                ...processedReviews[0],
                name: processedReviews[0]?.traveller
              }
            : undefined
        );
        setSecondMostPositiveReview(
          processedReviews[1]
            ? {
                ...processedReviews[1],
                name: processedReviews[1]?.traveller
              }
            : undefined
        );
      }
    } catch (error) {
      console.error('Error fetching rating counts:', error);
    }
  };
  const fetchRatingCounts = async () => {
    try {
      // Build where clause for rating counts
      const ratingCountsWhereClause: any = {
        product: { _eq: toursStrapiId },
        rating: { _gte: 4 }
      };

      const { data } = await client.query({
        query: FETCH_REVIEWS,
        variables: {
          where: ratingCountsWhereClause
        },
        fetchPolicy: 'no-cache'
      });

      const reviews = data.strapi_reviews;

      const counts: { [key: number]: number } = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
      };

      reviews.forEach((review: any) => {
        const rating = review.rating;
        let starCategory: number;

        // Only count ratings 4 and 5 since we filter for >= 4
        if (rating >= 4 && rating < 5) {
          starCategory = 4;
        } else if (rating === 5) {
          starCategory = 5;
        } else {
          return; // Skip ratings below 4
        }

        counts[starCategory]++;
      });

      setRatingCounts(counts);
    } catch (error) {
      console.error('Error fetching rating counts:', error);
    }
  };
  useEffect(() => {
    // Reset states when the route changes
    setShowPax(false);
    setIsPaxVisible(false);
    fetchBestReviews();
    fetchReviews();
    fetchRatingCounts();
    fetchReviewAggregate();
    setShowCountMessage(true);
  }, [router.query.slug]);
  const fetchReviews = async () => {
    try {
      setLoader(true);

      if (!toursStrapiId) {
        console.error('No strapi product ID found');
        setLoader(false);
        return;
      }

      // Build where clause for filtering
      const whereClause: any = {
        product: { _eq: toursStrapiId },
        rating: { _gte: 4 }
      };

      // Add rating filter if selected
      if (selectedRating && selectedRating !== 'all-stars') {
        const ratingNum = parseInt(selectedRating);
        if (ratingNum === 1 || ratingNum === 2 || ratingNum === 3) {
          // For ratings 1, 2, 3: create condition that returns no results
          whereClause.id = { _eq: -1 }; // Non-existent ID to ensure no results
        } else if (ratingNum === 4) {
          whereClause.rating = { _gte: 4, _lt: 5 };
        } else if (ratingNum === 5) {
          whereClause.rating = { _eq: 5 };
        }
      }

      // Calculate offset for pagination
      const offset = (currentPage - 1) * itemsPerPage;
      // Fetch reviews with GraphQL query
      const reviewsResponse = await client.query({
        query: FETCH_REVIEWS,
        variables: {
          limit: itemsPerPage,
          offset: offset,
          order_by: [{ created_at: 'desc' }],
          where: whereClause
        },
        fetchPolicy: 'no-cache'
      });

      const countResponse = await client.query({
        query: FETCH_REVIEWS,
        variables: {
          where: whereClause
        },
        fetchPolicy: 'no-cache'
      });
      const reviews = reviewsResponse?.data?.strapi_reviews || [];
      const processedReviews = reviews?.map((review: any) => ({
        ...review,
        name: review?.traveller,
        created_at: review?.created_at
      }));

      setReviews(processedReviews);

      const totalCount = countResponse?.data?.strapi_reviews?.length || 0;
      setReviewsCount(totalCount);
    } catch (error) {
      console.error('Error fetching reviews:', error);
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchReviewAggregate();
    fetchRatingCounts();
  }, []);

  useEffect(() => {
    if (
      !selectedRating ||
      selectedRating === 'all-stars' ||
      selectedRating === ''
    ) {
      setReviewsCount(totalReviewsCount);
      if (currentPage !== 1) {
        setCurrentPage(1);
      }
    }
    fetchReviews();
  }, [totalReviewsCount]);
  useEffect(() => {
    fetchReviews();
  }, [currentPage]);
  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
    fetchReviews();
  }, [selectedRating]);
  const updateTourContext = () => {
    updateTour({
      tour: product?.name,
      cardMessage: product?.cardMessage,
      //@ts-ignore
      tourId: product?.id,
      tourImage: product?.pageContent?.carousel?.map(
        (item: any) => item.url
      )[0],
      private: product?.private,
      ratingCount: reviewCount,
      ratingAvg: averageRating,
      guest: reviewCount,
      message: product?.cardMedia,
      city: product?.pageContent?.city,
      rezdyId: product?.duplicateRezdyId
        ? product?.duplicateRezdyId
        : product?.RezdyId
    });
  };
  const productSchema = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: product?.name,
    image: product?.pageContent?.carousel[0]?.url,
    description: product?.pageContent?.meta_description,

    offers: {
      '@type': 'Offer',
      priceCurrency: currency,
      price: selectedPrice?.prices?.adult || product?.price,
      availability: 'InStock',
      priceValidUntil: '2023-12-31',
      seller: {
        '@type': 'Organization',
        name: 'See Sight Tours'
      }
    },
    hasMerchantReturnPolicy: {
      '@type': 'MerchantReturnPolicy',
      returnFees: 'Free Cancellation 24 hours in advance',
      returnPolicyCountry: 'CA'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: averageRating || 4.9,
      bestRating: 5,
      ratingCount: reviewCount && reviewCount > 0 ? Math.floor(reviewCount) : 10
    },
    review: {
      '@type': 'Review',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: Math.round(bestReview?.rating ?? 5),
        bestRating: 5
      },
      author: {
        '@type': 'Person',
        name: bestReview?.name || 'John Doe'
      },
      datePublished: bestReview?.created_at
        ? dayjs(bestReview.created_at).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD')
    }
  };
  const tourSchema = {
    '@context': 'https://schema.org',
    '@type': 'TouristTrip',
    name: product?.name,
    description: product?.pageContent?.short_description,
    itinerary: product?.attractions?.map((item: any) => {
      return {
        '@type': 'TouristAttraction',
        name: item?.name,
        description: item?.cardSnippet,
        image: item?.heroMedia?.length > 0 ? item?.heroMedia[0].url : ''
      };
    }),
    touristType: 'Sightseeing',

    offers: {
      '@type': 'Offer',
      url: product?.pageContent?.canonical,
      price: selectedPrice?.prices?.adult || product?.price,
      priceCurrency: currency,
      availability: 'https://schema.org/InStock',
      priceValidUntil: '2023-12-31',
      validFrom: '2023-07-01',
      validThrough: '2023-12-31',
      seller: {
        '@type': 'Organization',
        name: 'See Sight Tours'
      }
    }
  };
  const trackButtonCall = async () => {
    try {
      if (typeof window !== 'undefined' && window.gtag) {
        await window.gtag('event', 'button_click', {
          category: 'interaction',
          action: 'button click',
          label: 'mobile-check-dates'
        });
      }
    } catch (error) {
      console.error('Error tracking button click:', error);
    }
  };
  const MOBILE_THRESHOLD = 768;

  const isMobile = () =>
    typeof window !== 'undefined' && window.innerWidth >= MOBILE_THRESHOLD;

  const [dropdownStates, setDropdownStates] = useState<boolean[]>(
    Array(6).fill(isMobile())
  );
  const [openMenuIndex, setOpenMenuIndex] = useState<string | null>(null);

  const handleOpenMenu = (index: string) => {
    if (openMenuIndex !== index) {
      setOpenMenuIndex(index);
    }
  };

  const handleCloseMenu = () => {
    setOpenMenuIndex(null);
  };
  useEffect(() => {
    if (typeof window !== 'undefined') {
      isMobile && setDropdownStates(Array(6).fill(isMobile()));
    }
  }, [typeof window !== 'undefined' ? window.innerWidth : null]);

  useEffect(() => {
    const handleRouteChange = () => {
      const delay = 2000;
      setTimeout(() => {
        setDropdownStates(Array(dropdownStates?.length).fill(false));
      }, delay);
    };
    router.events.on('routeChangeStart', handleRouteChange);
    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router.events, dropdownStates]);

  const desc = product?.pageContent?.long_description?.trim();
  let timeline;
  if (desc?.includes('\n\n')) {
    timeline = desc.split('\n\n');
  } else if (desc?.includes('\n')) {
    timeline = desc?.split('\n');
  } else if (desc?.includes('<br><br>')) {
    timeline = desc.split('<br><br>');
  } else {
    timeline = [desc];
  }
  useEffect(() => {
    if (showPax) {
      scrollToElement('mobile-pax');
    }
  }, [showPax]);

  const reviewState = {
    average: Number(averageRating),
    total: reviewCount
  };

  // Add useEffect to handle scroll visibility
  useEffect(() => {
    if (!showPax) return;
    if (showMobileGallery && !Mobile) {
      setIsPaxVisible(!isPaxVisible);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsPaxVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1
      }
    );

    if (paxRef.current) {
      observer.observe(paxRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [showPax, showMobileGallery]);
  const [showModal, setShowModal] = useState(false);

  const handleSeeMore = (review: any) => {
    setDetailModalData(review);
    setShowDetailModal(true);
  };
  const includedItems = product?.pageContent?.whats_included
    ? product.pageContent.whats_included
        .split('\n') // Split on line breaks
        .map((item: string) => item.trim())
        .filter((item: string) => item.length > 0)
    : [];

  const excludedItems = product?.pageContent?.whats_excluded
    ? product.pageContent.whats_excluded
        .split('\n') // Split on line breaks
        .map((item: string) => item.trim())
        .filter((item: string) => item.length > 0)
    : [];
  useEffect(() => {
    const fetchRecentBookings = async () => {
      try {
        const lastDay = new Date();
        lastDay.setHours(lastDay.getHours() - 24);

        const { data } = await client.query({
          query: FETCH_RECENT_BOOKINGS,
          variables: {
            productId: product?.id,
            lastDay: lastDay.toISOString()
          },
          fetchPolicy: 'no-cache'
        });
        const count = data?.boatnew_booking?.length || 0;
        setRecentBookingsCount(count);
      } catch (error) {
        console.error('Error fetching recent bookings:', error);
        setRecentBookingsCount(0);
      }
    };

    if (product?.id) {
      fetchRecentBookings();
    }
  }, [product?.id, router.query.slug]);

  return (
    <>
      <Head>
        <meta name="og:title" content={`${product?.pageContent?.title} `} />
        <meta
          name="og:description"
          content={product?.pageContent?.meta_description}
        />
        <title>{`${product?.pageContent?.title}`}</title>
        <meta
          name="description"
          content={product?.pageContent?.meta_description}
        />
        <link
          rel="canonical"
          href={replaceTripshepherdWithSeeSight(
            product?.pageContent?.canonical
          )}
        />
        <meta
          name="og:image"
          content={product?.pageContent?.carousel[0]?.url}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productSchema)
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(tourSchema)
          }}
        />
      </Head>
      {router.isFallback ? (
        <div role="status" className="w-full flex justify-center">
          <svg
            aria-hidden="true"
            className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <>
          <div className="flex flex-col w-full px-[5%] msm:px-[6%] lg:px-[4%] xl:px-[10%] 3xl:px-[14%] py-[3%] bg-[#]">
            <div className="flex mb-6 md:hidden">
              <PhotosHeader
                media={product?.pageContent?.carousel}
                productName={product?.name}
                productSlug={product?.slug}
                cardMessage={product?.cardMessage}
                showMobileGallery={showMobileGallery}
                setShowMobileGallery={setShowMobileGallery}
                isOpen={isImageModalOpen}
                setIsOpen={setIsImageModalOpen}
              />
            </div>
            <div className="flex flex-col gap-3">
              <div className="flex justify-between w-full mb-2 gap-[35px] ">
                <h1 className=" text-secondary mt-2 text-[24px] md:text-[28px] lg:text-3xl 2xl:text-[36px] font-[800] text-start ">
                  <span className=" font-black "> </span> {product?.name}{' '}
                </h1>
                {reviewCount === 0 && (
                  <div className="flex justify-center mt-2">
                    {' '}
                    <ShareButton
                      isOpen={openMenuIndex === product?.id}
                      onOpen={() => handleOpenMenu(product?.id)}
                      onClose={handleCloseMenu}
                      slug={product?.slug}
                    />
                  </div>
                )}
              </div>

              {reviewCount > 0 && (
                <div className="flex justify-between gap-2 cursor-pointer mb-4">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-3">
                      {averageRating >= 4.8 && (
                        <span className=" border h-[30px] border-secondary text-secondary bg-white rounded-[8px] p-1 text-sm font-semibold mr-1">
                          Top Rated
                        </span>
                      )}
                      {averageRating >= 4 && (
                        <>
                          <div className="flex items-center text-secondary font-semibold">
                            <div className="md:block hidden">
                              {' '}
                              <Rating
                                initialValue={averageRating}
                                allowFraction={true}
                                disableFillHover={true}
                                fillColor="#FFD700"
                                emptyColor="#9B9B9B"
                                readonly={true}
                                SVGstyle={{
                                  display: 'inline-block'
                                }}
                                size={25}
                              />
                            </div>
                            <div className="md:hidden block">
                              <Image
                                src={'/homestar.svg'}
                                width={14}
                                height={14}
                                alt="rating-star"
                                className="mb-[2px]"
                              />
                            </div>
                            <span className="md:text-base text-sm">
                              {averageRating}
                            </span>
                            <span className="md:text-base text-sm">/</span>
                            <span className="md:text-base text-sm">5</span>
                          </div>
                        </>
                      )}
                      <span
                        onClick={() => {
                          scrollToSection('reviews-section', -100);
                        }}
                        className="text-secondary md:text-base text-sm ml-1 underline hover:text-primary hover:font-semibold"
                      >
                        {`${totalReviewsCount} reviews`}{' '}
                        {averageRating >= 4 ? '' : 'for this tour'}{' '}
                      </span>
                    </span>
                  </div>
                  <div className="flex justify-center mt-2">
                    {' '}
                    <ShareButton
                      isOpen={openMenuIndex === product?.id}
                      onOpen={() => handleOpenMenu(product.id)}
                      onClose={handleCloseMenu}
                      slug={product.slug}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="md:flex hidden">
              <PhotosHeader
                media={product?.pageContent?.carousel}
                productName={product?.name}
                productSlug={product?.slug}
                cardMessage={product?.cardMessage}
                showMobileGallery={showMobileGallery}
                setShowMobileGallery={setShowMobileGallery}
                isOpen={isImageModalOpen}
                setIsOpen={setIsImageModalOpen}
              />
            </div>
            <div ref={descriptionRef}>
              <div className="mt-[10px] md:mt-[65px] w-full gap-[4%] 2xl:gap-[8%] flex flex-row">
                <div className=" w-full mmd:w-[60%]">
                  <div className="flex flex-col justify-start mb-4 gap-2">
                    <div className="flex justify-start flex-col w-full">
                      <div>
                        <p className="text-sm md:text-lg text-secondary">
                          {product?.pageContent?.short_description}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-6 w-full flex flex-col">
                    <KeyDetails
                      duration={product?.duration}
                      guests={product?.pageContent?.no_of_guests}
                      cancellation={product?.pageContent?.free_cancellation}
                      guide={product?.pageContent?.live_tour_guide}
                      skipTickets={product?.pageContent?.skip_ticket_line}
                      pickup={product?.pageContent?.pickup_dropoff}
                      meeting={product?.pageContent?.meeting_point}
                      confidence={product?.pageContent?.book_with_confidence}
                    />
                  </div>
                  {(positiveReview || secondMostPositiveReview) && (
                    <>
                      <div className="border-b border-[#EEEEEE] my-10 w-full" />
                      <div>
                        <h2 className="text-[20px] md:text-[22px] lg:text-[24px] font-bold mb-4">
                          See what other traveler&apos;s have to say about this
                          tour
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          {positiveReview && (
                            <ProductReviewCard
                              name={
                                positiveReview.name ||
                                positiveReview.traveller ||
                                'Anonymous'
                              }
                              rating={Number(positiveReview.rating)}
                              timeAgo={
                                positiveReview.created_at
                                  ? getTimeAgo(positiveReview.created_at)
                                  : ''
                              }
                              review={positiveReview.review}
                              onSeeMore={() => handleSeeMore(positiveReview)}
                              height={'h-[260px] max-[340px]'}
                            />
                          )}
                          {secondMostPositiveReview && (
                            <ProductReviewCard
                              name={
                                secondMostPositiveReview.name ||
                                secondMostPositiveReview.traveller ||
                                'Anonymous'
                              }
                              rating={Number(secondMostPositiveReview.rating)}
                              timeAgo={
                                secondMostPositiveReview.created_at
                                  ? getTimeAgo(
                                      secondMostPositiveReview.created_at
                                    )
                                  : ''
                              }
                              review={secondMostPositiveReview.review}
                              onSeeMore={() =>
                                handleSeeMore(secondMostPositiveReview)
                              }
                              height={'h-[260px] max-[340px]'}
                            />
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {product?.itineraries &&
                    product?.itineraries?.length > 0 &&
                    product?.itineraries !== null && (
                      <>
                        <div className="border-b border-[#EEEEEE] my-10 w-full" />
                        <TourRouteMap
                          itineraries={product?.itineraries}
                          cityCoordinates={
                            product?.pageContent?.city?.coordinates
                          }
                        />
                      </>
                    )}

                  <div
                    ref={paxRef}
                    id="mobile-pax"
                    className="flex mmd:hidden  justify-center"
                  >
                    <Included
                      shortDescription={product?.pageContent?.short_description}
                      longDescription={product?.pageContent?.long_description}
                      data={product?.pageContent?.tour_includes}
                      attractions={product?.attractions}
                      rezdyId={
                        product?.duplicateRezdyId
                          ? product?.duplicateRezdyId
                          : product?.RezdyId
                      }
                      reviewState={reviewState}
                      bestReview={bestReview}
                      updateTourContext={updateTourContext}
                      duration={product?.duration}
                      privateTour={product?.private}
                      showPax={showPax}
                      //@ts-ignore
                      tourId={
                        product?.duplicateRezdyId
                          ? product?.duplicateRezdyId
                          : product?.RezdyId
                          ? product?.RezdyId
                          : product?.id
                      }
                      name={product?.name}
                      slug={product?.slug}
                      city={product?.pageContent?.city}
                      bookingCutOffTime={product?.booking_cutoff}
                      productId={product?.id}
                    />
                  </div>
                  <div>
                    {product?.attractions && (
                      <>
                        <div className="border-b border-[#EEEEEE] my-10 w-full" />
                        <WhatYouWillSeeSection
                          product={product}
                          showModal={showModal}
                          setShowModal={setShowModal}
                        />
                      </>
                    )}
                  </div>

                  {product?.pageContent?.tour_highlights && (
                    <div>
                      <div className="border-b border-[#EEEEEE] my-10 w-full" />
                      <NeedToKnow
                        info={product?.pageContent?.tour_highlights}
                        heading="Highlights"
                      />
                    </div>
                  )}

                  {product?.pageContent?.tour_highlights && (
                    <div className="border-b border-[#EEEEEE] my-10 w-full" />
                  )}

                  {includedItems.length > 0 && (
                    <div className="my-6">
                      <InclusionExclusionGrid
                        items={includedItems}
                        type="included"
                        heading="Includes"
                      />
                    </div>
                  )}
                  {excludedItems.length > 0 && (
                    <div className="my-6">
                      <InclusionExclusionGrid
                        items={excludedItems}
                        type="excluded"
                        heading="Excludes"
                      />
                    </div>
                  )}
                  {includedItems.length > 0 ||
                    (excludedItems.length > 0 && (
                      <div className="border-b border-[#EEEEEE] my-10 w-full" />
                    ))}
                  {product?.pageContent?.tour_detailed_description && (
                    <>
                      <div className="border-b-2 my-8 border-[#EEEE]"></div>
                      <TourDetailedInfo
                        title="Description"
                        content={product.pageContent.tour_detailed_description}
                      />
                    </>
                  )}
                  {product?.pageContent?.important_information && (
                    <>
                      <div className="border-b border-[#EEEEEE] my-10 w-full" />
                      <>
                        <h2 className="text-[22px] md:text-[24px] lg:text-[26px] font-bold mb-4">
                          Important Information{' '}
                        </h2>
                        <HtmlInfoSection
                          content={product.pageContent.important_information}
                        />
                      </>
                    </>
                  )}
                  <div className="border-b border-[#EEEEEE] my-10 w-full" />

                  <>
                    <div id="reviews-section">
                      <ReviewsSection
                        rating={Number(averageRating)}
                        totalCount={reviewCount}
                        reviews={reviews}
                        setReviews={setReviews}
                        id={toursStrapiId}
                        productName={product?.name}
                        positiveReview={positiveReview}
                        secondMostPositiveReview={secondMostPositiveReview}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        setSelectedRating={setSelectedRating}
                        selectedRating={selectedRating}
                        totalReviewsCount={totalReviewsCount}
                        reviewsCount={reviewsCount}
                        fetchReviews={fetchReviews}
                        fetchReviewAggregate={fetchReviewAggregate}
                        fetchRatingCounts={fetchRatingCounts}
                        ratingCounts={ratingCounts}
                        loader={loader}
                        bookingId={bookingId}
                        isReviewModalOpen={isReviewModalOpen}
                        setIsReviewModalOpen={setIsReviewModalOpen}
                        checkExistingBookingReview={checkExistingBookingReview}
                        setBookingId={setBookingId}
                      />
                    </div>

                    <div className="border-b border-[#EEEEEE] my-10 w-full" />
                  </>
                </div>

                <div className="hidden mmd:block mmd:w-[37%]">
                  <div className="relative hidden mmd:flex mmd:sticky mmd:top-[100px] z-[39] h-auto justify-end w-full items-end">
                    <Included
                      shortDescription={product?.pageContent?.short_description}
                      longDescription={product?.pageContent?.long_description}
                      data={product?.pageContent?.tour_includes}
                      attractions={product?.attractions}
                      rezdyId={
                        product?.duplicateRezdyId
                          ? product?.duplicateRezdyId
                          : product?.RezdyId
                      }
                      reviewState={reviewState}
                      bestReview={bestReview}
                      updateTourContext={updateTourContext}
                      duration={product?.duration}
                      privateTour={product?.private}
                      showPax={showPax}
                      //@ts-ignore
                      tourId={
                        product?.duplicateRezdyId
                          ? product?.duplicateRezdyId
                          : product?.RezdyId
                          ? product?.RezdyId
                          : product?.id
                      }
                      name={product?.name}
                      slug={product?.slug}
                      city={product?.pageContent?.city}
                      bookingCutOffTime={product?.booking_cutoff}
                      productId={product?.id}
                    />
                  </div>
                </div>
              </div>

              <div>
                <RelatedTours relatedProducts={product?.relatedProducts} />
              </div>
            </div>
          </div>

          <div ref={footerRef}>
            <Newsletter />
            <Footer />
          </div>

          {(!showPax || (showPax && !isPaxVisible)) &&
            !showModal &&
            !isReviewModalOpen && (
              <div
                className={`fixed mmd:hidden px-[4%] bg-white items-center border-gray-400 flex justify-between bottom-0 right-0 w-full py-4 text-black ${
                  showMobileGallery ? 'rounded-none ' : ' rounded-md '
                } ${isImageModalOpen ? 'z-[1000]' : 'z-[10000]'}`}
              >
                <div className="font-bold">
                  <span className="text-sm font-semibold">From</span> $
                  <span>
                    {selectedPrice?.prices?.adult
                      ? Number(selectedPrice?.prices?.adult)
                      : Number(product?.price)}
                    &nbsp;
                    {currency}
                  </span>
                </div>

                <button
                  className="bg-primary text-white min-w-[30%] px-4 py-2 rounded-lg"
                  id="mobile-check-dates"
                  onClick={() => {
                    setShowMobileGallery(false);
                    trackButtonCall();
                    if (!showPax) {
                      setShowPax(true);
                      setTimeout(() => {
                        scrollToSection('mobile-pax', -60);
                      }, 100);
                    } else {
                      scrollToSection('mobile-pax', -60);
                    }
                  }}
                >
                  Check Dates
                </button>
              </div>
            )}
        </>
      )}
      {showReviewModal && (
        <AddReviewModal
          onClose={() => setShowReviewModal(false)}
          initialData={reviewFormData}
          id={product.id}
          fetchReviews={fetchReviews}
          fetchReviewAggregate={fetchReviewAggregate}
          fetchRatingCounts={fetchRatingCounts}
          setIsModalOpen={setIsModalOpen}
          selectedReviewData={selectedReviewData}
          setSelectedReviewData={setSelectedReviewData}
          setBookingId={setBookingId}
          tourName={product?.name}
        />
      )}
      {showDetailModal && detailModalData && (
        <DetailedReviewModal
          data={detailModalData}
          setShowModal={setShowDetailModal}
          productName={product?.name}
        />
      )}
      {showCountMessage && recentBookingsCount > 0 && (
        <CountMessage
          onClose={() => setShowCountMessage(false)}
          recentBookingsCount={recentBookingsCount}
        />
      )}
    </>
  );
};

interface Price {
  currency: string;
  prices: {
    adult: number;
    child: number;
    infant: number;
  };
}
export interface RATINGCOUNT {
  1: number;
  2: number;
  3: number;
  4: number;
  5: number;
}
export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const { slug } = params as { slug: string };

  try {
    // Fetch product data
    //this api doesnot have card media
    const productRes = await fetch(
      `${process.env.NEXT_PUBLIC_FIREBASE_WEBSITE_CONNECTION}/products/${slug}?lang=en`
    );
    if (!productRes.ok) {
      console.error(`Failed to fetch product data for slug: ${slug}`);
      return { notFound: true };
    }

    const productData = await productRes.json();

    if (!productData.success || !productData.data) {
      console.error(`No product found for slug: ${slug}`);
      return {
        redirect: { destination: '/404', permanent: false }
      };
    }
    let strapiProductId: number | null = null;
    try {
      const response = await client.query({
        query: FETCH_STRAPI_PRODUCT_ID,
        variables: { slug }
      });
      strapiProductId = response?.data?.strapi_Product?.[0]?.id || null;
    } catch (err) {
      console.error('Error fetching product ID from Strapi:', err);
    }
    let reviews = [];
    let reviewsForCount = [];
    let reviewsCount = 0;

    if (strapiProductId) {
      try {
        // Build where clause for reviews
        const reviewWhereClause: any = {
          product: { _eq: strapiProductId },
          rating: { _gte: 4 }
        };

        const reviewResponse = await client.query({
          query: FETCH_REVIEWS,
          variables: {
            limit: 6,
            offset: 0,
            order_by: [{ created_at: 'desc' }],
            where: reviewWhereClause
          }
        });

        const reviewResponseCount = await client.query({
          query: FETCH_REVIEWS,
          variables: {
            where: reviewWhereClause
          }
        });
        reviews = reviewResponse?.data?.strapi_reviews || [];
        reviewsForCount = reviewResponseCount?.data?.strapi_reviews || [];
        reviewsCount = reviewsForCount.length;
      } catch (err) {
        console.error('Error fetching reviews from Strapi:', err);
      }
    }

    return {
      props: {
        product: replaceTripshepherdWithSeeSight(productData.data),
        initialReviews: reviews,
        count: reviewsCount,
        totalCount: reviewsCount,
        toursStrapiId: strapiProductId
      }
    };
  } catch (error) {
    console.error('Error fetching product/review data:', error);
    return {
      redirect: { destination: '/404', permanent: false }
    };
  }
};
export default TourPage;
